import { render, staticRenderFns } from "./RiverChart.vue?vue&type=template&id=65caa7a7&"
import script from "./RiverChart.vue?vue&type=script&lang=js&"
export * from "./RiverChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports